/**
 * @fileoverview Mock API Handlers 索引
 *
 * 匯出所有 MSW (Mock Service Worker) handlers，包含：
 *
 * 1. goldCalculate (來自 ./goldCalculate.js)
 *    - POST /gold/calculate - 金價計算 API
 *
 * 2. goldWeightList (來自 ./goldWeightList.js)
 *    - GET /gold/weight-list - 金牌重量列表 API
 *
 * 3. orders (來自 ./orders.js)
 *    - POST /orders - 建立訂單
 *    - GET /orders - 訂單列表
 *    - GET /orders/:id - 訂單詳情
 *
 * 4. adminOrders (來自 ./adminOrders.js)
 *    - GET /admin/orders - 後台訂單列表
 *    - GET /admin/orders/:id - 後台訂單詳情
 *    - GET /admin/orders/:id/items - 訂單商品明細
 *
 * 總計: 8 個 mock API endpoints
 */

import { goldCalculateHandler } from "./goldCalculate";
import { goldWeightListHandlers } from "./goldWeightList";
import { frontOrdersHandlers } from "./orders";
import { adminOrdersHandlers } from "./adminOrders";

// 匯出所有 handlers
export const handlers = [
  goldCalculateHandler,
  ...goldWeightListHandlers,
  ...frontOrdersHandlers,
  ...adminOrdersHandlers,
];
